import AhoyTracker from 'shared/ahoy_tracker';
import Topic from 'shared/topic';

export default class MobilePremiumSubscribeModal {
  constructor() {
    this.elements = {
      player       : document.querySelector('.player-data'),
      modal        : document.querySelector('.premium-subscribe-modal'),
      openBtn      : document.querySelector('.js-premium-subscribe-button-open:not([href])'),
      closeBtn     : document.querySelector('.js-premium-subscribe-button-close'),
      defaulTitle  : document.querySelector('.js-watchpage-premium-banner-title.banner--default')
    };
    this.ahoy = (this.elements.modal) ? new AhoyTracker(this.elements.modal) : false;
  }

  init() {
    this.addOpenHandler();
    this.addCloseHandler();
    if(this.isLivestream()) {
      this.subscribePaymentBlockerShow();
    } else {
      this.setBackgroundBanner();
    }
  }

  destroy() {
    let oldOpenBtn = this.elements.openBtn;
    var newOpenBtn = oldOpenBtn.cloneNode(true);
    oldOpenBtn.parentNode.replaceChild(newOpenBtn, oldOpenBtn);
    this.elements.openBtn = newOpenBtn;
  }

  addOpenHandler() {
    if(this.elements.openBtn) {
      this.elements.openBtn.addEventListener("click", this.openModal.bind(this));
    }
  }

  addCloseHandler() {
    this.elements.closeBtn.addEventListener("click", this.closeModal.bind(this));
  }

  openModal() {
    this.elements.modal.classList.remove("hide");
    if(this.isLivestream()) {
      this.initPlayerPause();
    }
    this.sendGTMImpressionEvent();

    setTimeout(function(){
      this.elements.modal.classList.add("premium-subscribe-modal--animate");
      this.sendAhoyImpressionEvent();
    }.bind(this), 10);
  }

  closeModal() {
    this.elements.modal.classList.remove("premium-subscribe-modal--animate");
    if(this.isLivestream()) {
      this.initPlayerPlay();
    }

    setTimeout(function(){
      this.elements.modal.classList.add("hide");
    }.bind(this), 200);
  }

  setBackgroundBanner() {
    var banner = document.querySelector(".b-premium-subscribe-banner");
    var player = document.querySelector(".player-data");

    if( banner !== null && player !== null) {
      var videoImageUrl = player.getAttribute("data-video-image-url");

      banner.style.backgroundImage = "url(\"" + videoImageUrl + "\")";
      banner.classList.add("b-premium-subscribe-banner--image-enabled");
    }
  }

  sendGTMImpressionEvent() {
    window.dataLayer.push({
      event: 'impression',
      feature_name: this.elements.modal.getAttribute('data-gtm-name'),
      feature_location: this.elements.modal.getAttribute('data-gtm-loc'),
      feature_type: this.elements.modal.getAttribute('data-gtm-type'),
      feature_index: this.elements.modal.getAttribute('data-gtm-feature-index'),
      category_id: this.elements.modal.getAttribute('data-gtm-category-id'),
      feature_genre: this.elements.modal.getAttribute('data-gtm-feature-genre'),
      blocker_type: this.elements.modal.getAttribute('data-gtm-blocker-type'),
    });
  }

  sendAhoyImpressionEvent() {
    this.ahoy.sendEventImpression();
  }

  subscribePaymentBlockerShow() {
    Topic.subscribe('player/paymentblocker/show', this.openModal.bind(this));
  }

  isLivestream() {
    let type = this.elements.modal.getAttribute('data-gtm-type');
    return type == 'live';
  }

  initPlayerPlay() {
    if(window.player && window.player.isReady()) {
      window.player.tech().play();
    }
  }

  initPlayerPause() {
    if(window.player && window.player.isReady()) {
      window.player.tech().pause();
    }
  }
}
